import { createSlice } from "@reduxjs/toolkit";

export const utilizationData = createSlice({
  name: "utilizationData",
  initialState: {
    dailyData: [],
    weeklyData: [],
    monthlyData: [],
    customData: [],
    loading: false,
    error: null,
  },
  reducers: {
    setDailyData: (state, action) => {
      state.dailyData = action.payload;
    },
    setWeeklyData: (state, action) => {
      state.weeklyData = action.payload;
    },
    setMonthlyData: (state, action) => {
      state.monthlyData = action.payload;
    },
    setCustomData: (state, action) => {
      state.customData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setDailyData,
  setWeeklyData,
  setMonthlyData,
  setCustomData,
  setLoading,
  setError,
} = utilizationData.actions;

export default utilizationData.reducer;
